import { ColumnConfig } from "types/bankStatements";
import { needsAttention } from "../importedInvoiceUtils";

// master grid of the Imported invoices page: one row per invoice
export const importedInvoiceColumnConfig: ColumnConfig[] = [
  {
    columnId: "ordinalNumber",
    width: 50,
    reorderable: false,
    resizable: true,
    label: "",
    cellType: "ordinalnumber",
    sortable: false,
  },
  {
    columnId: "select",
    width: 40,
    reorderable: false,
    resizable: false,
    label: "",
    cellType: "select",
    sortable: false,
    additionalInfo: {
      rowIdField: "importedInvoiceId",
    },
  },
  {
    columnId: "invoiceNumber",
    width: 220,
    reorderable: true,
    resizable: true,
    sortable: true,
    label: "pct.importedInvoiceNumber.label",
    cellType: "customtext",
  },
  {
    columnId: "matchStateLabel",
    width: 130,
    reorderable: true,
    resizable: true,
    sortable: true,
    label: "pct.importedInvoiceMatchState.label",
    cellType: "customtext",
    additionalInfo: {
      redColorFn: (row) => needsAttention(row["matchState"]),
    },
  },
  {
    columnId: "issuedDateFormatted",
    width: 100,
    reorderable: true,
    resizable: true,
    sortable: true,
    label: "pct.importedInvoiceIssuedDate.label",
    cellType: "customtext",
  },
  {
    columnId: "dueDateFormatted",
    width: 100,
    reorderable: true,
    resizable: true,
    sortable: true,
    label: "pct.dueDate.label",
    cellType: "customtext",
  },
  {
    columnId: "payerDisplayName",
    width: 200,
    reorderable: true,
    resizable: true,
    sortable: true,
    label: "pct.payerName.label",
    cellType: "customtext",
    additionalInfo: {
      // the GOS link exists only when the payer code was resolved to a CRM partner
      gosLink: {
        idField: "payerClientId",
        linkType: "client",
      },
    },
  },
  {
    columnId: "payerCode",
    width: 110,
    reorderable: true,
    resizable: true,
    sortable: true,
    label: "pct.importedInvoicePayerCode.label",
    cellType: "customtext",
  },
  {
    columnId: "premiumAmount",
    width: 100,
    reorderable: true,
    resizable: true,
    sortable: true,
    label: "pct.premiumAmount.label",
    cellType: "customnumber",
  },
  {
    columnId: "isGroupInvoice",
    width: 60,
    reorderable: true,
    resizable: true,
    sortable: true,
    label: "pct.importedInvoiceIsGroup.label",
    cellType: "customcheckmark",
  },
  {
    columnId: "entryCount",
    width: 70,
    reorderable: true,
    resizable: true,
    sortable: true,
    label: "pct.entryCount.label",
    cellType: "customnumber",
    additionalInfo: { fractionDigits: 0 },
  },
  {
    columnId: "matchedEntryCount",
    width: 70,
    reorderable: true,
    resizable: true,
    sortable: true,
    label: "pct.matchedEntryCount.label",
    cellType: "customnumber",
    additionalInfo: { fractionDigits: 0 },
  },
  {
    columnId: "unmatchedEntryCount",
    width: 70,
    reorderable: true,
    resizable: true,
    sortable: true,
    label: "pct.unmatchedEntryCount.label",
    cellType: "customnumber",
    additionalInfo: {
      fractionDigits: 0,
      redColorFn: (row) => row["unmatchedEntryCount"] > 0,
    },
  },
  {
    columnId: "paidEntryCount",
    width: 70,
    reorderable: true,
    resizable: true,
    sortable: true,
    label: "pct.importedInvoicePaidEntryCount.label",
    cellType: "customnumber",
    additionalInfo: { fractionDigits: 0 },
  },
  {
    columnId: "paidAtSourceFormatted",
    width: 100,
    reorderable: true,
    resizable: true,
    sortable: true,
    label: "pct.importedInvoicePaidAtSource.label",
    cellType: "customtext",
  },
  {
    columnId: "pendingBankStatementEntryFormatted",
    width: 240,
    reorderable: true,
    resizable: true,
    sortable: true,
    label: "pct.importedInvoicePendingBankStatementEntry.label",
    cellType: "customtext",
  },
  {
    columnId: "externalId",
    width: 90,
    reorderable: true,
    resizable: true,
    sortable: true,
    label: "pct.importedInvoiceExternalId.label",
    cellType: "customtext",
  },
  {
    columnId: "importedAtFormatted",
    width: 100,
    reorderable: true,
    resizable: true,
    sortable: true,
    label: "pct.importedInvoiceImportedAt.label",
    cellType: "customtext",
  },
  {
    columnId: "importFileName",
    width: 240,
    reorderable: true,
    resizable: true,
    sortable: true,
    label: "pct.importedInvoiceImportFileName.label",
    cellType: "customtext",
  },
  {
    columnId: "options",
    width: 80,
    reorderable: true,
    resizable: true,
    sortable: false,
    label: "pct.options.label",
    cellType: "importedinvoiceoptions",
    additionalInfo: {
      rowIdField: "importedInvoiceId",
    },
  },
];
